<template>
  <div
    v-if="review_facility?.length > 0"
    style="padding-bottom:0;"
    class="full-width"
  >
    <div class="golf-good-price mb-10">
      <p class="c-black-text c-bold-text title-h3 m-0">
        {{ title }}
      </p>
      <p @click="pushRouter" class="m-0 text-see-more cursor-pointer">
        {{ $t("viewAll") }}
      </p>
    </div>
    <el-row :gutter="20">
      <el-col
        v-for="(item, index) in review_facility.slice(0, 8)"
        :key="index"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        :xl="6"
      >
        <card-review-facility
          style="margin-bottom: 15px;"
          class="w-100"
          :object-data="item"
          :title="item?.name"
          :location="item.location"
          :rating="item.rating"
          :reviews_count="item.reviews_count"
          :holes_amount="item.holes_amount"
          :description="item.description"
          :image="item?.images"
          :id="item?.id"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import CardReviewFacility from "@/components/wapV2/cards/CardReviewFacility.vue";
import ReviewFacility from "@/views/api/wapV2/review-facility";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "carousel-facility",
  components: {
    CardReviewFacility
  },
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  created() {
    this.onGetList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["review_facility"])
  },
  watch: {},

  data() {
    return {
      listData: [],
      query: {
        page: 1,
        limit: 8
      }
    };
  },
  methods: {
    ...mapActions(["set_data_review_facility"]),
    pushRouter() {
      return this.$router.push(`/san-noi-bat`);
    },
    onGetList() {
      if (this.review_facility.length > 0) return;
      ReviewFacility.get_review_facility().then(res => {
        const { error_code, data = [] } = res;
        if (error_code === 0 && data.length > 0) {
          const mapData = data.map(i => {
            const obj = {
              ...i,
              id: i.course_id,
              title: i.name,
              images: i.galleries
                .flatMap(item => item.images?.map(imgObj => String(imgObj.img).replace("http://", "https://")))
                .slice(0, 5)
            };
            return obj;
          });
          this.set_data_review_facility(mapData);
        }
      });
    }
  }
};
</script>

<style>
.slick-slide {
  padding-right: 10px;
  padding-left: 10px;
}
</style>

<style scoped lang="scss">
.golf-good-price {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
}
.title-h3 {
  font-size: 16px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.text-see-more {
  color: #858585;
  font-size: 12px;
}
@media screen and (min-width: 0px) and (max-width: 991px) {
  .title-h3 {
    font-size: 14px;
  }
}
@media screen and (min-width: 0px) and (max-width: 591px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .text-see-more {
    font-size: 10px;
  }
}
</style>
